import { AssetType as h } from "../../constants/url.js";
import { useLanguageContext as y } from "../../contexts/language/LanguageContext.js";
import l from "../generic/useApeironPathMaker.js";
import d from "./useFetchJson.js";
import { useQuery as g } from "@tanstack/react-query";
import * as k from "ramda";
import { useCallback as F, useEffect as J } from "react";
const C = (r) => {
  const { fetchNow: n = !0, key: a, path: t, deserialize: c } = r, { makePath: u } = l(), { language: i } = y(), { fetchJson: f } = d({
    url: u(h.Json, t)
  }), { data: o, isFetching: m, refetch: e } = g({
    enabled: n,
    queryKey: [a || t],
    queryFn: async () => {
      const s = await f();
      return c(s);
    }
  }), p = F(async () => (await e()).data, [e]);
  return J(() => {
    k.isNotNil(o) && e();
  }, [i]), {
    data: o,
    isFetching: m,
    fetch: p
  };
};
export {
  C as default
};
//# sourceMappingURL=useReactQueryFetchJson.js.map
